import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gax-side-panel-dialog-actions',
  templateUrl: './side-panel-dialog-actions.component.html',
  styleUrl: './side-panel-dialog-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SidePanelDialogActionsComponent {}
